





















import { dwollaCustomerIdFromUrl } from '@/util/dwolla'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BeneficialOwnersDialog extends Vue {

  @Prop({ default: false }) readonly opened!: boolean
  
  closeDialog() {
    this.$emit('update:opened', false)
  }

  get me() {
    return this.$store.getters.me
  }

  customerId(customerUrl: string) {
    return dwollaCustomerIdFromUrl(customerUrl)
  }
}
